import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { IQualification } from 'src/app/model/qualifications/iqualification';
import { QualificationFormatter } from './qualification-formatter';

@Component({
    selector: 'app-view-qualifications',
    styleUrls: ['./view-qualifications.component.scss'],
    templateUrl: './view-qualifications.component.html',
    standalone: false
})
export class ViewQualificationsComponent implements OnInit {

  private readonly ROW_BREAK = '<br/>';

  @Input() public qualifications: UntypedFormArray;

  constructor() { }

  public get tableRows(): { qual: string, basis: string }[] {


    let q = this.qualifications ? this.qualifications.controls
      .map((control: UntypedFormGroup) => control.value)
      .map((value: IQualification) => this.toRow(value))
      : [];
    return q;
  }

  public ngOnInit() {
  }

  private toRow(qualification: IQualification): { qual: string, basis: string } {

    return {
      basis: QualificationFormatter.formatBases(qualification.bases).join(this.ROW_BREAK),
      qual: QualificationFormatter.formatQualification(qualification).join(this.ROW_BREAK),
    };
  }
}
